module.exports = __webpack_public_path__ + "static/media/pharmacy.60b121ab.jpg";